import { Provider } from '@angular/core';
import { VehiclesApiService } from '@api';
import { VehicleApiMockService } from './vehicle-api-mock.service';

export const VEHICLE_PROVIDERS: Provider[] = [{ provide: VehiclesApiService, useClass: VehicleApiMockService }];
